// const baseUrl = {
//   dev: process.env.NODE_ENV == 'production'?"http://atest.woaap.com:11035":'',   // 测试地址
//   prod: "",   // 正式地址
// }
const host = window.location.origin;
const getdata = process.env.NODE_ENV == 'production'? host :'';  // 测试地址
// const getdata =  "http://atest.woaap.com:11035";

const urls = {
  login: `${getdata}/miniapp/admin/admin-api/login`,   // 登录
  logout: `${getdata}/miniapp/admin/admin-api/logout`,   // 退出登陆
  getListData: `${getdata}/miniapp/admin/admin-api/writer-record/get-count`,   // 获取经销商/门店
  getCardType: `${getdata}/miniapp/admin/admin-api/writer-record/card`,   // 获取卡券
  getMember: `${getdata}/miniapp/admin/admin-api/writer-record/get-writer`,   // 获取核销员
  verificationIndex: `${getdata}/miniapp/admin/admin-api/writer-record/index`,   // 核销记录数据请求
  verificationExport: `${getdata}/miniapp/admin/admin-api/writer-record/export`,   // 核销记录数据请求
  getStoreData: `${getdata}/miniapp/admin/admin-api/writer-record/get-store`,   // 获取门店核销数据
  getStoreEdit: `${getdata}/miniapp/admin/admin-api/writer-record/store/{id}/edit`,   // 获取某个门店核销数据
  getStoreExport: `${getdata}/miniapp/admin/admin-api/writer-record/store/{id}/export`,   // 导出某个门店核销数据 +
  getCardData: `${getdata}/miniapp/admin/admin-api/writer-record/get-card`,   // 获取卡券核销数据
  getCardEdit: `${getdata}/miniapp/admin/admin-api/writer-record/card/{id}/edit`,   // 获取某个卡券核销数据
  getCardExport: `${getdata}/miniapp/admin/admin-api/writer-record/card/{id}/export`,   // 导出某个卡券核销数据 +


}

export default urls;